<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    @hideModal="hideModal()"
    size="xl"
  >
    <template #header>
    </template>
    <template #body>
      <Create :order="invoice"></Create>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Create from '@/components/Dashboard/Views/BusinessBundle/exsbdocument/Create'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'DocumentCreateFromInvoiceModal',
  components: {
    BaseModal,
    Create
  },
  watch: {
    created (val) {
      if (val) {
        this.setCreateFromInvoiceModal(false)
      }
    }
  },
  computed: {
    ...mapGetters({
      isVisible: 'exsbdocument/createModal/isVisibleCreateFromInvoiceModal',
      invoice: 'exsbinvoice/show/invoiceAdapter',
      created: 'exsbdocument/create/created'
    })
  },
  methods: {
    hideModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'exsbdocument/createModal/toggleCreateFromInvoiceModal',
      setCreateFromInvoiceModal: 'exsbdocument/createModal/setCreateFromInvoiceModal'
    })
  }
}
</script>

<style scoped>

</style>
